import { createFileRoute } from "@tanstack/react-router"

import { validateAdLibrarySearch } from "~/components/AdLibrary/adFilters"
import { AdLibraryPage } from "~/components/AdLibrary/AdLibraryPage"
import CustomHead from "~/components/SEOHead/CustomHead"
import { SuperAdminLayout } from "~/layouts/SuperAdminLayout"

function AdminAdLibraryRoute() {
  return (
    <SuperAdminLayout fixedViewport>
      <CustomHead title="Admin · Ad Library" />
      <AdLibraryPage />
    </SuperAdminLayout>
  )
}

export const Route = createFileRoute("/admin/ad-library")({
  validateSearch: validateAdLibrarySearch,
  component: AdminAdLibraryRoute,
})
